import * as RegistrationReducer from './RegistrationReducer';
import * as MessageReducer from './MessageReducer';
import * as BpiReducer from './BpiReducer';
import * as CollectReducer from './CollectReducer';

// The top-level state object
export interface ApplicationState {
    registrationState: RegistrationReducer.RegistrationState | undefined;
    messageState: MessageReducer.MessageState | undefined;
    bpiState: BpiReducer.BpiState | undefined;
    collectState: CollectReducer.CollectState | undefined;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    registrationState: RegistrationReducer.reducer,
    messageState: MessageReducer.reducer,
    bpiState: BpiReducer.reducer,
    collectState: CollectReducer.reducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
